import styled from 'styled-components';

import Image from '@stencil/image';

export const SoldOutWrapperDiv = styled.div(
  props => `
  margin-top: 7rem;
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  height: 8rem;
  width: 98%;
  background-color:${props.theme.colors.goRed.light};
  border-radius:${props.theme.misc.borderRadius.large};
  // margin-top:${props.theme.spacing.xlarge};

`,
);

export const IconWrapperSpan = styled.span`
  margin-right: 3rem;
`;

export const SoldOutInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.base} ${props.theme.spacing.xlarge} ${props.theme.spacing.base};
`,
);

export const TimerImage = styled(Image)(
  props => `

    margin-right:${props.theme.spacing.base};
    width: 4.2rem;
    height: 4.2rem;

`,
);

export const SoldOutTextWrappDiv = styled.div(
  props => `
  margin-top: ${props.theme.spacing.base};
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;

`,
);

export const FirstTxtPara = styled.p(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  color:${props.theme.colors.goRed.base};
  font-weight:bold;
  font-size:${props.theme.font.custom(16)};
  padding-bottom:${props.theme.spacing.xsmall};
`,
);

export const AlternateDateLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  padding-top:${props.theme.spacing.xsmall};

  color: ${props.theme.colors.goBrandBlue.base};
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);
